import SDK from '@realeyes/data-collection-sdk';
import ProxyLogger from './ProxyLogger';

export default class ProxyCollectionSdk {
    async init(configOverrides) {
        this.config = Object.assign({}, configOverrides, window.hfSdkParams);

        const { jsModuleSettings } = window;

        const isFaceDetectionEnabled = (jsModuleSettings.faceDetectionEnabled ?? '').toLowerCase() === 'true';
        const isActivityValidatorEnabled = (jsModuleSettings.activityValidatorEnabled ?? '').toLowerCase() === 'true';

        this.config.recorderOptions.testOptions.validators = {};
        
        if (isFaceDetectionEnabled) {
            this.config.recorderOptions.testOptions.validators.faceDetection =
                { checkInterval: jsModuleSettings.faceDetectionInterval };
        };

        if (isActivityValidatorEnabled) {
            this.config.recorderOptions.testOptions.validators.activity =
                { checkInterval: jsModuleSettings.activityValidatorInterval };
        }

        this.sdkInstance = new SDK(this.config);

        this.recorder = await this.sdkInstance.getMediaDeviceRecorder();

        const sdkLogger = await this.sdkInstance.registerLogMessageTracker("messages");
        this.logger = new ProxyLogger(sdkLogger);
    }

    getRecorder() {
        return this.recorder;
    }

    logMessage(sessionId, logSource, logType, clientTime, logMessage) {
        const message = { sessionId: sessionId, logSource: logSource, logType: logType, clientTime: clientTime, logMessage: logMessage };

        return this.logger.log(message);
    }

    logMessages(messages) {
        const deferred = [];
        for (let i = 0; i < messages.length; i++) {
            const m = messages[i];
            deferred.push(this.logMessage(m.sessionId, m.logSource, m.logType, m.clientTime, m.logMessage));
        }

        return Promise.all(deferred);
    }
}
